// import "tailwindcss/tailwind.css";
import { CodeIcon } from "@heroicons/react/solid";
import React from "react";
import ProjectCard from "../Molecules/ProjectCard";
import HeroIcon from "../Atoms/HeroIcon";
import { useTranslation } from "react-i18next";

interface ProjectsProps {}

const Projects: React.FC<ProjectsProps> = () => {
  const { t } = useTranslation();

  return (
    <section id="projects">
      <div className="container px-5 py-10 mx-auto text-center">
        <div className="flex flex-col w-full mb-10">
          <HeroIcon
            Icon={CodeIcon}
            className="mx-auto inline-block w-10 mb-4"
          />

          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            {t("projects.title")}
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base text-white">
            {t("projects.description")}
          </p>
        </div>
        <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
          <ProjectCard />
        </div>
      </div>
    </section>
  );
};
export default Projects;
